import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { MAX_TRANSACTION_NUMBERS } from '../../utils/transactionNumbers';

const TransactionNumberChoices = ({ existing, choices, unticked, onToggle, disabled }) => {
  if (!existing.length) return null;
  const known = new Set(existing.map((n) => n.toLowerCase()));
  const { candidates, ticked, tooMany } = choices;

  return (
    <Box>
      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, display: 'block' }}>
        Numbers on this service
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {candidates.map((number) => (
          <FormControlLabel
            key={number.toLowerCase()}
            disabled={disabled}
            control={(
              <Checkbox
                size="small"
                checked={!unticked.includes(number.toLowerCase())}
                onChange={() => onToggle(number.toLowerCase())}
                sx={{ py: 0.25 }}
              />
            )}
            label={(
              <Typography sx={{ fontSize: '0.8125rem' }}>
                {number}{known.has(number.toLowerCase()) ? '' : ' (new)'}
              </Typography>
            )}
          />
        ))}
      </Box>
      <Typography variant="caption" sx={{ color: tooMany ? 'error.main' : 'text.secondary' }}>
        {tooMany
          ? `Tick at most ${MAX_TRANSACTION_NUMBERS} numbers (${ticked.length} ticked)`
          : ticked.length === 0
            ? 'None ticked: the service keeps its current numbers'
            : `${ticked.length} of ${MAX_TRANSACTION_NUMBERS} kept. Untick a number to remove it`}
      </Typography>
    </Box>
  );
};

export default TransactionNumberChoices;
